module.exports = "<div class=\"splash-content\">\n  <div class=\"splash-container\">\n    <div class=\"login-logo error\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n  </div>\n</div>\n<pioneer-iata-by-default-modal\n  data-se-id=\"app-component-iata-by-default-modal\">\n</pioneer-iata-by-default-modal>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/auth/secured-home/secured-home.component.html
// module id = kt5u
// module chunks = 0